module.exports = __webpack_public_path__ + "img/hdtoollogo2.9a644132.png";